import React from 'react';

const Thumbnail = () => (
  <div className="w-full h-20 rounded-lg bg-zinc-100 dark:bg-zinc-800 p-2 flex items-center justify-center">
    <div className="w-20 h-12 bg-zinc-200 dark:bg-zinc-700 rounded flex items-center justify-center">
      <div className="w-6 h-6 bg-primary/40 rounded-full flex items-center justify-center">
        <div className="w-0 h-0 border-l-[6px] border-l-white border-y-[4px] border-y-transparent ml-0.5" />
      </div>
    </div>
  </div>
);

export default Thumbnail;
